import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canAccess } from '../../guards/guards';
import { UserTableWrapperComponent } from './user-table-wrapper/user-table-wrapper.component';

const routes: Routes = [
    {
        path: '',
        component: UserTableWrapperComponent,
        canActivate: [canAccess],
        data: {
            title: 'USERMANAGEMENT_NAVIGATION_TITLE',
            allowedRoles: ['maintenance', 'admin', 'instructor']
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UserManagementRoutingModule {}
